import DetailVertical from "./DetailVertical.page";

export default DetailVertical;
